import States from './States.js';

export default function AddAdditionalState(additionalState) {
  let states = States();

  states = states.concat(additionalState);
  return  states.sort((a, b) => (a.label > b.label) ? 1 : ((a.label < b.label) ? -1 : 0));
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/AddAdditionalState.js